import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import CompanyName from '../../commonComponents/CompanyName';
import { AppContextType } from '../../../context/AppContext';
import useAppContext from '../../../hooks/useAppContext';
import { DecisionType } from '../../../static/types/commonTypes/decisionType';
import { LegalEntityType } from '../../../static/types/commonTypes/legalEntityType';
import { IndividualPersonType } from '../../../static/types/commonTypes/individualType';
import { CompanyNameType } from '../../../static/types/commonTypes/companyNameType';
import Address from '../../commonComponents/Address';
import { AddressType } from '../../../static/types/commonTypes/addressType';
import { ManagerType } from '../../../static/types/commonTypes/managerType';
import { getCityWithPreposition } from '../../../utils/functions/getCityWithPreposition';
import LegalEntity from '../../commonComponents/LegalEntity';
import ManagerList from '../../commonComponents/ManagerList';
import IndividualPerson from '../../commonComponents/IndividualPerson';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import DecisionWithQuality from '../../commonComponents/DecisionWithQuality';
import { formatObjectText } from '../../../utils/functions/formatObjectText';
import { useDraftManager } from '../../../hooks/useDraftManager';


interface AnnonceProps {
    txtAnnonce: string;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    updateActiveIndex: (index: number) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;
}

const OuvertureDissolutionAnticipe: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateDenomination,
    updateActiveIndex,
    societyType,

}) => {
    const {
        managers, setManagers,
        managersValidity, setManagersValidity,
        managersChecked, setManagersChecked,

        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        legalEntity, setLegalEntity,
        legalEntityValidity, setLegalEntityValidity,
        legalEntityChecked, setLegalEntityChecked,

        individual, setIndividual,
        individualValidity, setIndividualValidity,
        individualChecked, setIndividualChecked,

        address, setAddress,
        addressValidity, setAddressValidity,
        addressChecked, setAddressChecked,

        liquidationHeadquarter, setLiquidationHeadquarter,
        typeAddress, setTypeAddress,

        decisionWithQualityAndEffectiveDate,
        setDecisionWithQualityAndEffectiveDate,
        decisionWithQualityAndEffectiveDateValidity,
        setDecisionWithQualityAndEffectiveDateValidity,
        decisionWithQualityAndEffectiveDateChecked,
        setDecisionWithQualityAndEffectiveDateChecked,

        lastTab, setLastTab,

    } = useAppContext() as AppContextType

    const liquidationHeadquarterOptions = ["Au siège social", "Chez le liquidateur", "Autre adresse"]
    const sameLiquidationHeadquarterOptions = ["Au siège social", "Chez le liquidateur"]
    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType]
    const [activeTab, setActiveTab] = useState<string>('companyName');
    const [visitedTabs, setVisitedTabs] = useState(['companyName']);
    const [submissive, setSubmissive] = useState<boolean>(false)

    const { pushDraftContent } = useDraftManager()

    const goToSupportPresse = () => {
        updateActiveIndex(2);
    }


    // Soumettre le formulaire
    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab('companyName')
        }
        else if (!decisionWithQualityAndEffectiveDateValidity) {
            setActiveTab('decision')
        }
        else if (!legalEntityValidity) {
            setActiveTab('theSociety')
        }
        else if (!managersValidity) {
            setActiveTab('liquidator')
        }
        else if (liquidationHeadquarter === "Autre adresse" && !individualValidity) {
            setActiveTab('liquidationHeadquarter')
        }
        else if (typeAddress === 1 && !addressValidity) {
            setActiveTab('correspondenceAddress')
        }

        let tempLiquidationHeadquarterValidity = liquidationHeadquarter === "Autre adresse" ? individualValidity : true
        let tempAddressValidity = typeAddress === 1 ? addressValidity : true

        return companyNameValidity && decisionWithQualityAndEffectiveDateValidity && legalEntityValidity && managersValidity && tempLiquidationHeadquarterValidity && tempAddressValidity
    };

    const switchTab = (tab: string) => {
        setActiveTab(tab);
    };

    const handleSubmit = (e: React.FormEvent) => {

        e.preventDefault();

        const isValid = validate()

        if (isValid) {
            const pluralSubjects = ["Les associés","Les actionnaires"];
            const termes = [   "AG Extraordinaire","AG Ordinaire","AG Mixte"]
            const termess = termes.includes(decisionWithQualityAndEffectiveDate.decisionNature) ? "Aux termes de" : "";
            const verb = pluralSubjects.includes(decisionWithQualityAndEffectiveDate.decisionQuality) ? "ont" : "a";
            const managerText = (manager: ManagerType): string => {
                if (manager.person === "Personne morale") {
                    return manager.entityDetails.rcs ? ` ${manager.entityDetails.companyName}, ${manager.entityDetails.legalForm} au capital de ${manager.entityDetails.capital} €, ayant son siège social ${manager.entityDetails.address} ${manager.entityDetails.additionalAddress ?? ""} ${manager.entityDetails.postalCode} ${manager.entityDetails.city}, ${manager.entityDetails.rcs} RCS ${getCityWithPreposition(manager.entityDetails.registrationOffice)}` : ``
                }
                else if (manager.person === "Personne physique") {
                    return manager.personDetails.lastName ? ` ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}, demeurant ${manager.personDetails.address} ${manager.personDetails.additionalAddress ?? ""} ${manager.personDetails.postalCode} ${manager.personDetails.city}` : ``
                }
                else return ""
            }

            let decisionText = (decision: DecisionType): string => {
                // Vérifier si la décision appartient à "termes"
                if (termes.includes(decision.decisionNature)) {
                    return `${termess} ${decision.decisionNature === "AG Extraordinaire" ? "l'AGE" : decision.decisionNature === "AG Ordinaire" ? "l'AGO" : decision.decisionNature === "AG Mixte" ? "l'AG Mixte" : decision.decisionNature} en date du ${decision.decisionDate} ${decisionWithQualityAndEffectiveDate.decisionQuality} ${verb} décidé la dissolution et sa mise en liquidation amiable ${decisionWithQualityAndEffectiveDate.effectiveDate ? `à compter du ${decisionWithQualityAndEffectiveDate.effectiveDate}` : ''}`;
                } else {
                    // Format alternatif si ce n'est pas une AG 
                    return `Le ${decision.decisionDate}, ${decision.decisionNature} ${verb} décidé la dissolution et sa mise en liquidation amiable ${decisionWithQualityAndEffectiveDate.effectiveDate ? `à compter du ${decisionWithQualityAndEffectiveDate.effectiveDate}` : ''}`;
                }
            };
            

            

            const tempText = `${legalEntity.companyName},
${legalEntity.legalForm} au capital de ${legalEntity.capital} €.
Siège social :
${legalEntity.address} ${legalEntity.additionalAddress ?? ""} ${legalEntity.postalCode} ${legalEntity.city}
${decisionText(decisionWithQualityAndEffectiveDate)}, nommé ${managers.length > 1 ? 'liquidateurs' : 'liquidateur'} ${managers.map((liquidatorItem: ManagerType) => managerText(liquidatorItem)).join(" et ")}, et fixé le siège de liquidation ${sameLiquidationHeadquarterOptions.includes(liquidationHeadquarter) ? ` ${liquidationHeadquarter.toLowerCase()}` : ` chez ${individual.civility === 'Monsieur' ? 'M.' : 'Mme'} ${individual.lastName} ${individual.firstName}, demeurant ${individual.address} ${individual.additionalAddress ?? ""} ${individual.postalCode} ${individual.city}`}. ${typeAddress === 1 ? `La correspondance sera adressée ${address.address} ${address.additionalAddress ?? ""} ${address.postalCode} ${address.city}` : ``}
Mention au RCS ${getCityWithPreposition(legalEntity.registrationOffice)}.`;

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName)
            setSubmissive(true)
        }
    };

    const handleNext = () => {
        if (activeTab === 'companyName') {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                switchTab(getNextTab('companyName'))
            }
        } else if (activeTab === 'decision') {
            setDecisionWithQualityAndEffectiveDateChecked(true)
            if (decisionWithQualityAndEffectiveDateValidity) {
                switchTab(getNextTab('decision'))
            }
        } else if (activeTab === 'theSociety') {
            setLegalEntityChecked(true)
            if (legalEntityValidity) {
                switchTab(getNextTab('theSociety'))
            }
        } else if (activeTab === 'liquidator') {
            setManagersChecked(true)
            if (managersValidity) {
                switchTab(getNextTab('liquidator'))
            }
        } else if (activeTab === 'liquidationHeadquarter') {
            if (liquidationHeadquarter === "Autre adresse") {
                setIndividualChecked(true)
                if (individualValidity) {
                    switchTab(getNextTab('liquidationHeadquarter'))
                }
            }
            else switchTab(getNextTab('liquidationHeadquarter'))
        } else if (activeTab === 'correspondenceAddress') {
            if (typeAddress === 1) {
                setAddressChecked(true)
                if (addressValidity) {
                    setSubmissive(true)
                }
            }
            else setSubmissive(true)
        }
    };

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false);
    };

    
    useEffect(() => {
        // Si on vient d'un brouillon, restaurer l'onglet actif
        if ( lastTab ) {
            setActiveTab(lastTab);
            // Ajouter tous les onglets précédents comme visités
            const tabOrder = ['companyName', 'decision', 'theSociety', 'liquidator', 'liquidationHeadquarter', 'correspondenceAddress' ];
            const currentTabIndex = tabOrder.indexOf(lastTab);
            const visitedTabsArray = tabOrder.slice(0, currentTabIndex + 1);
            setVisitedTabs(visitedTabsArray);
        }
    }, []);

    
    useEffect(() => {
        setLastTab(activeTab);
    }, [activeTab]);

    const getNextTab = (currentTab: string) => {
        switch (currentTab) {
            case 'companyName':
                return 'decision';
            case 'decision':
                return 'theSociety';
            case 'theSociety':
                return 'liquidator';
            case 'liquidator':
                return 'liquidationHeadquarter';
            case 'liquidationHeadquarter':
                return 'correspondenceAddress';
            default:
                return currentTab;
        }
    };

    const getPreviousTab = (currentTab: string) => {
        switch (currentTab) {
            case 'correspondenceAddress':
                return 'liquidationHeadquarter';
            case 'liquidationHeadquarter':
                return 'liquidator';
            case 'liquidator':
                return 'theSociety';
            case 'theSociety':
                return 'decision';
            case 'decision':
                return 'companyName';
            default:
                return currentTab;
        }
    };

    const updateDecision = (data: Partial<DecisionType>) => setDecisionWithQualityAndEffectiveDate({ ...decisionWithQualityAndEffectiveDate, ...data });

    const tabs =[
        {key: 'companyName', label: 'Raison Sociale'},
        {key: 'decision', label: 'Décision'},
        {key: 'theSociety', label: 'La société'},
        {key: 'liquidator', label: 'Le liquidateur'},
        {key: 'liquidationHeadquarter', label: 'Le siège de liquidation'},
        {key: 'correspondenceAddress', label: 'Adresse de correspondance'},

    ]
    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>

            <ToastContainer />

            <form onSubmit={handleSubmit}>
                {
                    activeTab === 'companyName' &&
                    <CompanyName
                        changeCompanyName={(updatedData: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...updatedData })}
                        checked={companyNameChecked}
                        companyName={companyName}
                        onValidationChange={(isValid: boolean) => setCompanyNameValidity(isValid)}
                    />
                }

                {
                    activeTab === 'decision' &&
                    <DecisionWithQuality
                        decisionWithQuality={decisionWithQualityAndEffectiveDate}
                        draftFieldName = 'decisionWithQualityAndEffectiveDate'
                        checked={decisionWithQualityAndEffectiveDateChecked}
                        dateLabel='Date'
                        changeDecision={updateDecision}
                        onValidationChange={(isValid: boolean) => setDecisionWithQualityAndEffectiveDateValidity(isValid)}
                        decisionQualityOptions={[
                            "L'associé unique",
                            "Les associés",
                            "Les actionnaires"
                        ]}
                        decisionNatureOptions={[
                            "AG Extraordinaire",
                            "AG Ordinaire",
                            "AG Mixte",
                            "Le gérant",
                            "Le président",
                            "Le conseil d'administration",
                            "Décision unanime des associés"
                        ]}
                    />
                }

                {
                    activeTab === 'theSociety' &&
                    <LegalEntity
                        checked={legalEntityChecked}
                        onValidationChange={(isValid: boolean) => setLegalEntityValidity(isValid)}
                        legalEntity={legalEntity}
                        changeLegalEntity={(updatedData: Partial<LegalEntityType>) => setLegalEntity({ ...legalEntity, ...updatedData })}
                        societyType={societyTypeOptions}
                        companyName={companyName}
                        setCompanyName={(updatedData: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...updatedData })}
                        draftFieldName = 'legalEntity'
                    />
                }

                {
                    activeTab === 'liquidator' &&
                    <>
                        <p><strong>Saisir le nom et l'adresse du (ou des) liquidateur(s).</strong> </p>
                        <ManagerList
                            addButtonText='Ajouter un liquidateur'
                            removeButtonText='Supprimer le dernier liquidateur'
                            checked={managersChecked}
                            managers={managers}
                            setManagers={setManagers}
                            setManagersValidity={setManagersValidity}
                            societyTypeOptions={societyTypeOptions}
                            draftFieldName = 'managers'
                        />
                    </>
                }

                {
                    activeTab === 'liquidationHeadquarter' &&
                    <>
                        <div className='d-flex'>
                            <label htmlFor="adresseliquidation" className="col-sm-2 col-form-label">Adresse</label>
                            <select
                                className="form-select"
                                id="adresseliquidation"
                                onChange={event => {
                                    setLiquidationHeadquarter(event.target.value)
                                    pushDraftContent({ liquidationHeadquarter: event.target.value })
                                }}
                                value={liquidationHeadquarter}
                            >
                                {
                                    liquidationHeadquarterOptions.map((option, key) =>
                                        <option key={key} value={option}> {option} </option>
                                    )
                                }

                            </select>
                        </div>
                        {
                            liquidationHeadquarter === "Autre adresse" &&
                            <IndividualPerson
                                changeIndividual={(partialIndividual: Partial<IndividualPersonType>) => setIndividual({ ...individual, ...partialIndividual })}
                                checked={individualChecked}
                                individual={individual}
                                onValidationChange={(isValid: boolean) => setIndividualValidity(isValid)}
                                draftFieldName = 'individual'
                            />
                        }
                    </>
                }

                {
                    activeTab === 'correspondenceAddress' &&
                    <>
                        <div className="d-flex mb-2">
                            <label htmlFor="typeAddress" className="col-sm-2 col-form-label">Saisir une adresse</label>
                            <select
                                className="form-select"
                                id="typeAddress"
                                onChange={event => {
                                    setTypeAddress(Number(event.target.value))
                                    pushDraftContent({ typeAddress: Number(event.target.value) })
                                }}
                                value={typeAddress}
                            >
                                <option value={1} >Oui</option>
                                <option value={0} >Non</option>
                            </select>
                        </div>
                        {
                            typeAddress === 1 &&
                            <Address
                                address={address}
                                draftFieldName = 'address'
                                changeAddress={(partialAddress: Partial<AddressType>) => setAddress({ ...address, ...partialAddress })}
                                checked={addressChecked}
                                onValidationChange={(isValid: boolean) => setAddressValidity(isValid)}
                            />
                        }
                        {
                            submissive &&
                            <div className="mt-4">
                                <h4>Texte de l'annonce:</h4>
                                <textarea
                                    className="form-control"
                                    rows={5}
                                    value={txtAnnonce}
                                    disabled
                                />
                            </div>
                        }
                    </>
                }

                <div className='button-container'>
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'companyName' &&
                            <button color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handlePrevious} >
                                <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                Modifier mon annonce
                            </button>
                        }

                        {
                            activeTab === 'correspondenceAddress' &&
                            <button type="submit" onClick={handleNext}>Mettre à jour mon annonce
                                <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                            </button>
                        }

                        {
                            activeTab !== 'correspondenceAddress' &&
                            <button color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handleNext} >
                                Suivant
                                <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        }

                        {
                            submissive && activeTab === 'correspondenceAddress' &&
                            <button color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={goToSupportPresse} >
                                Sélection du support
                                <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>

                        }

                    </div>
                </div>

            </form>
        </>
    );
};

export default OuvertureDissolutionAnticipe;